<template>
    <van-notice-bar :scrollable="false">
        您访问的页面未找到！
      </van-notice-bar>
</template>

<script>
export default {}
</script>
